import GATSBY_COMPILED_MDX from "/home/runner/work/raian.github.io/raian.github.io/content/blog/motivation/index.mdx";
import React from "react";
import {Link, graphql} from "gatsby";
import {MDXProvider} from "@mdx-js/react";
import BlogLayout from "../components/blogLayout";
import Layout from "../components/layout";
import Seo from "../components/seo";
import {rhythm, scale} from "../utils/typography";
import {DiscussionEmbed} from "disqus-react";
import {createGlobalStyle} from 'styled-components';
import 'prismjs/themes/prism-coy.css';
const GlobalStyle = createGlobalStyle`
  ${() => {
  return null;
}}  
  
  pre code {
    margin: 0;
    padding: 0;
    white-space: pre;
    border: none;
    background: transparent;
  }
  
  .highlight pre {
    background-color: #f8f8f8;
    border: 1px solid #cccccc;
    font-size: 13px;
    line-height: 19px;
    overflow: auto;
    padding: 6px 10px;
    border-radius: 3px;
  }
  
  pre {
    margin-top: -15px;
    margin-bottom: 5px;
    background-color: #f8f8f8;
    border: 1px solid #cccccc;
    font-size: 13px;
    line-height: 19px;
    overflow: auto;
    padding: 6px 10px;
    border-radius: 3px;
  }
  
  pre code, pre tt {
    background-color: transparent;
    border: none;
  }

`;
function BlogPostTemplate({location, data, pageContext, children}) {
  const siteTitle = data.site.siteMetadata.title;
  const {previous, next} = pageContext;
  const post = data.mdx;
  const disqusConfig = {
    shortname: data.site.siteMetadata.disqusID,
    config: {
      identifier: post.frontmatter.title,
      siteTitle
    }
  };
  return React.createElement(Layout, null, React.createElement(Link, {
    to: "/blog"
  }, React.createElement("h3", {
    style: {
      margin: 0,
      marginBottom: rhythm(2)
    }
  }, "Blog")), React.createElement(BlogLayout, {
    location: location,
    title: siteTitle
  }, React.createElement(Seo, {
    title: post.frontmatter.title,
    description: post.frontmatter.description,
    keywords: [`blog`, `solutions architect`, `technical deep dive`]
  }), React.createElement("h4", {
    style: {
      marginBottom: 7,
      marginTop: 0
    }
  }, React.createElement("i", null, post.frontmatter.title)), React.createElement("p", {
    style: {
      ...scale(-1 / 5),
      display: `block`,
      marginBottom: rhythm(1 / 3),
      marginTop: 0
    }
  }, post.frontmatter.date), React.createElement(GlobalStyle), React.createElement(MDXProvider, null, children), React.createElement("hr", {
    style: {
      marginBottom: rhythm(1)
    }
  }), React.createElement("div", null, React.createElement("ul", {
    style: {
      display: `flex`,
      flexWrap: `wrap`,
      justifyContent: `space-between`,
      listStyle: `none`,
      padding: 0,
      marginLeft: 0
    }
  }, React.createElement("li", null, previous && React.createElement(Link, {
    to: previous.frontmatter.slug,
    rel: "prev"
  }, "← ", React.createElement("i", null, previous.frontmatter.title))), React.createElement("li", null, next && React.createElement(Link, {
    to: next.frontmatter.slug,
    rel: "next"
  }, React.createElement("i", null, next.frontmatter.title), " →")))), React.createElement(DiscussionEmbed, disqusConfig)));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const blogPostQuery = graphql`
  query BlogPostBySlug($id: String) {
    site {
      siteMetadata {
        author,
        title,
        disqusID
      }
    }
    mdx(id: {eq: $id}) {
      id
      excerpt(pruneLength: 160)
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
      }
      internal {
        contentFilePath
      }
    }
  }
`;
